module.exports = __webpack_public_path__ + "static/media/logo-white.d980d9eb.svg";